import { Anchor, Breadcrumbs, Card, Grid } from '@mantine/core';
import queryString from 'query-string';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import AssetForm from '../../components/Assets/AssetForm';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';
import useUploadAsset from '../../helpers/useUploadAsset';

const page = `${Page['assets']}`;

const AssetsNewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const search = queryString.parse(location.search);
  const tab = search.tab;

  const [asset] = useState({
    title: `New file`,
    description: 'New description',
  });
  const [userError, setUserError] = useState();

  const { uploadReferenceImage, uploadDocument } = useUploadAsset(setUserError);

  const { accountId, domainId } = useParams();

  const handleSaveAsset = (asset, file) => {
    const onComplete = () => {
      navigate({
        pathname: location.pathname.replace(`/assets/new`, '/assets'),
        search: `?tab=${tab}`,
      });
    };

    if (tab === 'documents') {
      uploadDocument(asset, file, onComplete);
    } else {
      uploadReferenceImage(asset, file, onComplete);
    }
  };

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/assets` },
    { title: 'New' },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <AssetForm asset={asset} saveAsset={handleSaveAsset} closeModal={null} tab={tab} />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default AssetsNewPage;
